import React from 'react'
import { If } from './helpers'
import { get } from './fetch'
import { Link, withRouter } from 'react-router-dom'
import Icon from '../components/Icon'
import Image from '../components/Image'
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { withData } from '../modules/helpers'
import history from './history'
import DisplayStars from '../components/DisplayStars'
import Flag from '../components/Flag'
import Date from '../components/Date'
import SiteStatus from '../components/SiteStatus'
import { isValid, parseISO, formatDistanceToNow } from 'date-fns'
import ArticleStatus from '../components/ArticleStatus'

const sToHMS = (seconds) => {
    seconds = parseInt(seconds)
    var hours = parseInt(seconds / 3600)
    seconds = seconds % 3600
    var minutes = parseInt(seconds / 60)
    seconds = seconds % 60
    return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
}

// let site_options = []
// const get_site_array = () =>
//     get('site')
//         .then(result => result.json())
//         .then(result => (site_options = result.map(site => ({ ...site, value: site.id }))))

// const CompetitorLabel_ =
const CompetitorLabel = withRouter(({ match, label, id }) => {
    const site_id = match.params.site_id
    const suffix = (site_id && '/' + site_id) || ''
    return <Link to={`/competitor/view/${id}${suffix}`}>{label}</Link>
})
const model_array = [
    {
        name: 'site',
        visible: true,
        label: (object) => object.label,
        AddBtn_label: 'Add a website',
        view: (object) => `/site/edit/${object.id}`,
        edit: (object) => `/site/edit/${object.id}`,
        dropdown: [
            (object) => (
                <Link key={`dd-seo-${object.id}`} to={'/site/view/' + object.id + '/search-console'} className="dropdown-item">
                    SEO
                </Link>
            ),
        ],
        list: [
            (obj) => (
                <div>
                    <Flag locale={obj.locale} className="mr-1" />
                    <Link to={'/site/view/' + obj.id}>{obj.label}</Link>
                    <If condition={!!obj.url}>
                        <br />
                        <small>{obj.url}</small>
                    </If>
                    <br />
                    <small>{(obj.published && <SiteStatus site={obj} />) || null}</small>
                    {(obj.tagline && <em>{obj.tagline}</em>) || <span className="badge badge-warning">No tagline</span>}
                    <br />
                    {obj.published_articles_count} published article{(obj.articles_count !== 1 && 's') || ''}
                </div>
            ),
            (obj) => (
                <>
                    {(obj.author && obj.author !== 'null' && <></>) || (
                        <div>
                            <div className="badge badge-danger">No author</div>
                        </div>
                    )}
                    {(!obj.background_src && (
                        <div>
                            <div className="badge badge-danger">No Background</div>
                        </div>
                    )) ||
                        null}
                    {(!obj.logo_src && (
                        <div>
                            <div className="badge badge-danger">No Logo</div>
                        </div>
                    )) ||
                        null}
                    {(!obj.favicon_src && (
                        <div>
                            <div className="badge badge-danger">No Favicon</div>
                        </div>
                    )) ||
                        null}
                </>
            ),
            // 'tracking_id',
        ],
        form_definition: [
            { label: 'Label', name: 'label', type: 'text' },
            { label: 'URL', name: 'url', type: 'text' },
            { label: 'Tagline', name: 'tagline', type: 'text' },
            { label: 'Key', name: 'key', type: 'text' },
            { label: 'Affiliate of', name: 'affiliate_of', type: 'text' },
            { label: 'Tracking ID', name: 'tracking_id', type: 'text' },
            { label: 'Locale', name: 'locale', type: 'text' },
            { label: 'Google Analytics', name: 'ga', type: 'text' },
            { label: 'Existing Wordpress', name: 'from_wordpress', type: 'text' },
            { label: 'Author name', name: 'author', type: 'text' },
            { label: 'Image', name: 'background__image', type: 'image', key: 'background' },
            { label: 'Logo', name: 'logo__image', type: 'image', key: 'logo' },
            { label: 'Favicon PNG', name: 'favicon__image', type: 'image', key: 'favicon' },
        ],
    },
    {
        name: 'competitor',
        visible: true,
        label: (object) => object.label,
        AddBtn_label: 'Add a competitor',
        view: (object) => `/competitor/edit/${object.id}`,
        edit: (object) => `/competitor/edit/${object.id}`,
        list: [
            (object) => (
                <>
                    <CompetitorLabel {...object} />
                    <small className="d-block">
                        <span className="text-success">{object.url}</span>
                        <a className="text-success" href={'https://dereferer.me/?' + escape(object.url)} target="_blank" rel="noopener noreferrer">
                            <Icon name="external" className="mx-1" />
                            Visit
                        </a>
                    </small>
                </>
            ),
            (object) => (object.sitemap && <>{object.nb_competitor_pages} pages</>) || null,
            (object) => (object.sitemap && <>{object.nb_affiliate_links_competitor_pages} affiliate pages</>) || null,
            (object) =>
                (object.sitemap && (
                    <>
                        <Icon name="sitemap" className="mr-1" />
                        sitemap
                    </>
                )) ||
                null,
        ],
        form_definition: [
            { label: 'Name', name: 'label', type: 'text' },
            { label: 'URL', name: 'url', type: 'text' },
            { label: 'Sitemap URL', name: 'sitemap', type: 'text' },
            { label: 'Locale', name: 'locale', type: 'text' },
        ],
    },
    {
        name: 'article',
        visible: true,
        label: (object) => object.title,
        AddBtn: withData({ query: 'site', prop_name: 'site_array' })((props) => {
            return (
                <UncontrolledDropdown>
                    <DropdownToggle caret color="primary">
                        Add an article
                    </DropdownToggle>
                    <DropdownMenu>
                        {(props.site_array || [])
                            .sort((a, b) => a.label.localeCompare(b.label))
                            .map((site) => (
                                <DropdownItem key={site.id}>
                                    <Link to={'/article/edit/?site_id=' + site.id}>
                                        <Flag locale={site.locale} className="mr-2" />
                                        {site.label}
                                    </Link>
                                </DropdownItem>
                            ))}
                    </DropdownMenu>
                </UncontrolledDropdown>
            )
        }),
        AddBtn_label: 'Add an article',
        view: (object) => `/article/edit/${object.id}`,
        edit: (object) => `/article/edit/${object.id}`,
        dropdown: [
            (object) =>
                (object.from_wordpress && (
                    <Link key={`dropdown-${object.id}`} to={'/article/redirect-images/' + object.id} className="dropdown-item">
                        Image redirects
                    </Link>
                )) ||
                false,
            (object) => (
                <Link key={`dd-resources-${object.id}`} to={'/resources/' + object.id} className="dropdown-item">
                    Resources
                </Link>
            ),
            (object) => (
                <Link key={`dd-queries-${object.id}`} to={'/article/queries/' + object.id} className="dropdown-item">
                    Queries
                </Link>
            ),
            (object) => (
                <Link key={`dd-seo-${object.id}`} to={'/article/edit/' + object.id + '/search-console'} className="dropdown-item">
                    SEO
                </Link>
            ),
            (object) => (
                <Link key={`dd-translation-${object.id}`} to={'/article/translate/' + object.id} className="dropdown-item">
                    Create translation
                </Link>
            ),
            (object) => (
                <Link key={`dd-duplicate-${object.id}`} to={'/article/duplicate/' + object.id} className="dropdown-item">
                    Duplicate
                </Link>
            ),
        ],
        list: [
            (object) => (object.background__image && <Image {...object.background__image} resize={{ width: 90, height: 90 }} />) || null,
            (object) => (
                <span>
                    <Flag locale={object.locale} className="mr-2" />
                    <Link to={`/article/edit/${object.id}`}>{object.title}</Link>
                    <br />
                    <If condition={!!object.permalink}>
                        <small>/{object.permalink}</small>
                    </If>
                    <If condition={!!object.created_at}>
                        <br />
                        <small>
                            {(
                                <>
                                    {isValid(parseISO(object.created_at)) && formatDistanceToNow(parseISO(object.created_at))} ago (
                                    <Date>{object.created_at}</Date>)
                                </>
                            ) || null}
                        </small>
                    </If>
                    <If condition={object.manual_link_error}>
                        <br />
                        <span className="badge badge-danger">Link errors</span>
                    </If>
                    <If condition={!!object.from_wordpress && !!object.old_permalink}>
                        <br />
                        <small className="text-secondary">/{object.old_permalink}</small>
                    </If>
                    {object.href_array?.map((a) => (
                        <React.Fragment key={a.id}>
                            <br />
                            <small>
                                {(a.translated_from__article_id && (
                                    <>
                                        <Flag locale={object.href_array.find((o) => o.id === a.translated_from__article_id)?.locale} className="mr-2" />{' '}
                                        <i className="fal fa-arrow-right mr-2" />
                                    </>
                                )) ||
                                    null}
                                <Flag locale={a.locale} className="mr-2" />
                                {(a.published && (
                                    <span className="text-success">
                                        <i className="fal fa-check mr-2" />
                                    </span>
                                )) || (
                                    <span className="text-secondary">
                                        <i className="fal fa-times mr-2" />
                                    </span>
                                )}
                                <Link to={`/article/edit/${a.id}`}>{a.title}</Link>
                            </small>
                        </React.Fragment>
                    ))}
                </span>
            ),
            (object) => <ArticleStatus status_id={object.status_id} />,
            (object) =>
                (object.time && (
                    <span className="alt-visible text-muted">
                        <Icon name="clock" /> {sToHMS(object.time)}
                    </span>
                )) ||
                null,
            (object) =>
                (object.click_nb && (
                    <span className="text-muted">
                        <Icon name="click" /> {object.click_nb}
                    </span>
                )) ||
                null,
            (object) =>
                (
                    <>
                        {(object.published && (
                            <div className="text-success">
                                <i className="fal fa-check" /> Published
                            </div>
                        )) || (
                            <div className="text-secondary">
                                <i className="fal fa-times mr-2" /> Offline
                            </div>
                        )}
                        {(object.active != 1 && (
                            <div className="text-muted">
                                <Icon name="trash" /> deleted
                            </div>
                        )) ||
                            null}
                    </>
                ) || null,
            // object => object.article_draft_id && <em className="text-muted">draft</em> || null,
        ],
        form_definition: [
            // { label: 'Site', name: 'site_id', type: 'select', options: () => (site_options) },
            { label: 'Title', name: 'title', type: 'text' },
            { label: 'Description', name: 'description', type: 'textarea' },
            { label: 'Wordpress Permalink', name: 'old_permalink', type: 'text' },
            { label: 'Permalink', name: 'permalink', type: 'text' },
            { label: 'Image', name: 'background__image', type: 'image', key: 'background' },
            { label: 'Text', name: 'body', type: 'page-editor' },
        ],
    },
    {
        name: 'article_rating',
        visible: true,
        label: (object) => object.note,
        AddBtn_label: 'Add a rating',
        view: (object) => `/article_rating/edit/${object.id}`,
        edit: (object) => `/article_rating/edit/${object.id}`,
        list: [
            (obj) => (
                <>
                    <div className={'pl-2 ' + ((parseFloat(obj.note) < 3 && 'text-danger') || '')}>
                        {(parseFloat(obj.note) < 3 && <Icon name="warning" className="mr-2" />) || null}
                        {obj.note} / 5
                    </div>
                    <DisplayStars note={obj.note} />
                </>
            ),
            (obj) => <Link to={'/article/edit/' + obj.article_id}>{obj.article_title}</Link>,
            'created_at',
        ],
        form_definition: [],
    },
    {
        name: 'snippet',
        visible: true,
        label: (object) => object.keywords,
        AddBtn_label: 'Add a snippet',
        view: (object) => `/snippet/edit/${object.id}`,
        edit: (object) => `/snippet/edit/${object.id}`,
        list: [
            (obj) => (
                <div>
                    <Link to={'/snippet/view/' + obj.id}>{obj.keywords}</Link>
                </div>
            ),
        ],
        form_definition: [],
    },
]

export default model_array
